import { Box, Card, CardContent, Typography } from "@mui/material";

import { HomePageButton } from "@/src/pages/consumer/HomePage/HomePageContent";

export type VehicleImageSize = "small" | "medium" | "large";

const VEHICLE_IMAGE_SIZE_OPTIONS: Record<
  VehicleImageSize,
  { width: number; height: number }
> = {
  small: { width: 180, height: 112 },
  medium: { width: 200, height: 125 },
  large: { width: 200, height: 125 }
};

interface VehicleStartAuctionCardContentProps {
  label: string;
  backgroundUrl: string[];
  onAuctionListingClick: () => void;
  imageSize?: VehicleImageSize;
  imageRightOffset?: number;
  imageTopOffset?: number;
  abTestId?: string;
}

const VehicleStartAuctionCard = ({
  label,
  backgroundUrl,
  onAuctionListingClick,
  imageSize = "medium",
  imageRightOffset = -30,
  imageTopOffset,
  abTestId
}: VehicleStartAuctionCardContentProps) => {
  const { width, height } = VEHICLE_IMAGE_SIZE_OPTIONS[imageSize];

  return (
    <Card
      sx={{
        display: "flex",
        position: "relative",
        minWidth: ["100%", "100%", "280px"],
        maxWidth: ["100%", "340px"],
        width: "100%",
        height: "158px",
        borderRadius: "40px",
        p: 2
      }}
    >
      <Box
        sx={{
          backgroundImage: backgroundUrl,
          position: "absolute",
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "right bottom",
          width: `${width}px`,
          height: `${height}px`,
          right: imageRightOffset,
          ...(imageTopOffset !== undefined && { top: imageTopOffset })
        }}
      />
      <Box sx={{ position: "relative", pb: 6 }}>
        <CardContent sx={{ p: 1, maxWidth: "60%" }}>
          <Typography component="div" variant="h5">
            {label}
          </Typography>
        </CardContent>
        <HomePageButton
          color="primary"
          variant="contained"
          onClick={onAuctionListingClick}
          buttonText="Aloita nyt"
          abTestId={abTestId}
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "max-content"
          }}
        />
      </Box>
    </Card>
  );
};

export default VehicleStartAuctionCard;
